// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__2wnlS"};